import { matchPath } from "react-router-dom";
import UserRole from "@lxp-app/utils/roles";

interface RouteRole {
  path: string;
  roles: UserRole[];
}

// add path and role which you want to allow.
const userRoles: RouteRole[] = [
  {
    path: "/calendar/calendar-dashboard-admin",
    roles: [UserRole.ADMIN, UserRole.CREATOR]
  },
  { path: "/learning-admin", roles: [UserRole.ADMIN] },
  {
    path: "/authoring/content-authoring",
    roles: [UserRole.CREATOR, UserRole.REVIEWER]
  },
  { path: "/create-event", roles: [UserRole.CREATOR] },
  {
    path: "/event-author/session/:id/:step?",
    roles: [UserRole.CREATOR, UserRole.REVIEWER]
  },
  {
    path: "/event-author/agenda/:id",
    roles: [UserRole.CREATOR, UserRole.REVIEWER]
  },
  { path: "/event-author/event/:id/:step?", roles: [UserRole.CREATOR] },
  { path: "/event-review/:id", roles: [UserRole.REVIEWER] },
  // {path:"/profile/manager-dashboard", roles: [UserRole.ADMIN]},
  {
    path: "/authoring/learningpath-authoring",
    roles: [UserRole.CREATOR, UserRole.REVIEWER]
  },
  {
    path: "/authoring/question-paper-authoring",
    roles: [UserRole.ASSESSMENT_CREATOR]
  },
  {
    path: "/authoring/assessment-authoring",
    roles: [UserRole.ASSESSMENT_ADMIN, UserRole.RECRUITER]
  },
  {
    path: "/authoring/event-authoring",
    roles: [UserRole.CREATOR, UserRole.REVIEWER]
  },
  {
    path: "/authoring/learning-path/:id",
    roles: [UserRole.CREATOR, UserRole.REVIEWER]
  },
  {
    path: "/authoring/course-authoring/:id",
    roles: [UserRole.CREATOR, UserRole.REVIEWER]
  },
  {
    path: "/super-admin/user-group-authoring",
    roles: [UserRole.USER_GROUP_CREATOR]
  },
  {
    path: "/super-admin/user-group-authoring/:id",
    roles: [UserRole.USER_GROUP_CREATOR]
  },
  {
    path: "/super-admin/user-group-authoring/:id/manage-users",
    roles: [UserRole.USER_GROUP_CREATOR]
  },
  {
    path: "/reports",
    roles: [UserRole.REPORT_ADMIN]
  }
];

export const checkRole = (
  currentPath: string,
  userRoleList: UserRole[]
): boolean => {
  for (const { path, roles } of userRoles) {
    // will use react router method to match :id with id.
    const match = matchPath(path, currentPath);
    if (match) {
      return !userRoleList.some((role: UserRole) => roles.includes(role));
    }
  }
  return false; // Deny if no matching route pattern
};
